import * as THREE from 'three';
import AbstractObject from '@scene/misc/object';
import defaultOptions from '@object-generators/wood-connection/defaultOptions';

export default class Nail extends AbstractObject {

  constructor(options) {
    super();
    this.options = {
      radius: options.radius || defaultOptions.nail.radius,
      height: options.height || 3,
      color: defaultOptions.materials.nailColor
    };
    this.init();
  }

  init() {
    const nailGeometry = new THREE.CylinderGeometry(
      this.options.radius,
      this.options.radius,
      2,
      32
    );

    const nailMaterial = new THREE.MeshStandardMaterial({
      color: this.options.color,
      roughness: defaultOptions.materials.properties.metal.roughness,
      metalness: defaultOptions.materials.properties.metal.metalness
    });

    const nail = new THREE.Mesh(nailGeometry, nailMaterial);

    this.mesh.add(nail);
  }

  setPosition(position) {
    this.mesh.position.copy(position);
  }

  get mesh() {
    return this.object.mesh;
  }

  get size() {
    return {
      radius: this.options.radius,
      height: this.options.height
    };
  }

} 



// WEBPACK FOOTER //
// ./src/object-view/objects/nail/nail.js